module.exports = __webpack_public_path__ + "img/product-placeholder-56.97df287.png";